import { render, staticRenderFns } from "./ConfirmStep.vue?vue&type=template&id=5598c3e8&scoped=true&"
import script from "./ConfirmStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./ConfirmStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ConfirmStep.vue?vue&type=style&index=0&id=5598c3e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598c3e8",
  null
  
)

export default component.exports